import React from 'react';

import Typography from '@material-ui/core/Typography';
import cx from 'classnames';
import { Link } from 'react-router-dom';

import PlaySmallIcon from '../../assets/icons/PlaySmallIcon';
import { BREAKPOINTS_VALUES, colorsPalette } from '../../theme';
import { createCategoryLink } from '../../utils/helpers';
import { CardDurationInfo } from '../Card';
import { LazyLoadImage } from '../LazyloadImage';
import { CategoryLabel } from '../UI/CategoryLabel';
import DifficultyIcon from '../UI/DifficultyIcon';
import { ProgressLine } from '../UI/ProgressLine';
import { VideoInterface } from './Video';
import { landscapeStyles } from './styles';

export const LandScapeVideo: React.FC<VideoInterface> = ({
  id,
  title,
  duration,
  userName,
  categories,
  difficulty,
  previewUrl,
  description,
  setVideoModalStatus,
  setVideoModalData,
  videoWidth,
  background,
  progress,
  handleClick,
  durationNumb,
  link,
  expertLink,
  verseId,
  bumperUrl,
}) => {
  const memoizedStylesFunc = React.useMemo(() => landscapeStyles(background, videoWidth), [
    background,
    videoWidth,
  ]);
  const classes = memoizedStylesFunc();
  const categoryName = categories && Array.isArray(categories) ? categories[0]?.title : null;
  const categoryLink = createCategoryLink(categories?.[0]);

  const playVideo = () => {
    if (handleClick || link) {
      handleClick && handleClick(id);
    } else {
      setVideoModalStatus(true);
      setVideoModalData({
        verseId: verseId,
        duration: durationNumb,
        title: title,
        expertName: userName,
        bumperUrl,
      });
    }
  };

  return (
    <div className={classes.videoWrap}>
      {link ? (
        <Link to={link}>
          <div className={cx(classes.imgWrap, 'video-preview-wrapper')} onClick={playVideo}>
            <LazyLoadImage
              className={classes.videoImg}
              path={previewUrl}
              alt={title}
              draggable={false}
              srcset={[{ width: 420 }, { width: 370 }, { width: 350 }, { width: 340 }]}
              sizes={`(max-width:${BREAKPOINTS_VALUES['sm']}px) 420px, (max-width: ${BREAKPOINTS_VALUES['md']}) 370px, (max-width:${BREAKPOINTS_VALUES['lg']}px) 350px, 340px`}
              imageWrapperClass={classes.lazyWrapper}
              objectFitPolyfill="cover"
            />

            <div className={classes.btnWrap}>
              <PlaySmallIcon className={classes.btn} color={colorsPalette.white} />
            </div>
          </div>
        </Link>
      ) : (
        <div className={cx(classes.imgWrap, 'video-preview-wrapper')} onClick={playVideo}>
          <LazyLoadImage
            className={classes.videoImg}
            path={previewUrl}
            alt={title}
            draggable={false}
            srcset={[{ width: 420 }, { width: 370 }, { width: 350 }, { width: 340 }]}
            sizes={`(max-width:${BREAKPOINTS_VALUES['sm']}px) 420px, (max-width: ${BREAKPOINTS_VALUES['md']}) 370px, (max-width:${BREAKPOINTS_VALUES['lg']}px) 350px, 340px`}
            imageWrapperClass={classes.lazyWrapper}
            objectFitPolyfill="cover"
          />
          <div className={classes.btnWrap}>
            <PlaySmallIcon className={classes.btn} color={colorsPalette.white} />
          </div>
        </div>
      )}

      <div className={classes.catDifWrap}>
        {categoryName && (
          <CategoryLabel url={categoryLink} name={categoryName} wrapperClass={classes.category} />
        )}
        <DifficultyIcon difficulty={difficulty} />
      </div>

      <div className={classes.textWrap}>
        {link ? (
          <Link to={link} className={classes.link}>
            <Typography variant="h3" component="h3" className={classes.title} onClick={playVideo}>
              {title}
            </Typography>
            <Typography className={classes.description}>{description}</Typography>
          </Link>
        ) : (
          <>
            <Typography variant="h3" component="h3" className={classes.title} onClick={playVideo}>
              {title}
            </Typography>
            <Typography className={classes.description}>{description}</Typography>
          </>
        )}
        {(userName || duration) && (
          <CardDurationInfo durationName={userName} duration={duration} link={expertLink} />
        )}
        {(progress || progress === 0) && <ProgressLine width={progress} />}
      </div>
    </div>
  );
};

export default LandScapeVideo;
